import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "ai-pricing-component",
    id: "ai-pricing-component"
};
import AiPricingComponent from 'conversationsApp/AiPricing';
import { createApp } from 'conversationsApp/vue3';
import { inject, reactive } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AiPricing',
    setup(__props, { expose }) {
        const store = inject('store');
        const route = inject('route');
        const router = inject('router');
        console.log('Store value is', store);
        const localState = reactive({
            aiPricingComponent: null,
        });
        const mountAiPricingPage = () => {
            var _a;
            if ((_a = localState.aiPricingComponent) === null || _a === void 0 ? void 0 : _a.unmount) {
                localState.aiPricingComponent.unmount();
            }
            const elements = document.querySelectorAll('.ai-pricing-component');
            elements.forEach(el => {
                var _a;
                // Create a new instance for each element
                const aiPricingComponentInstance = createApp(AiPricingComponent, {
                    store,
                    route,
                    router
                });
                // Store the instance in localState for reference
                window['aiPricingComponent'] = aiPricingComponentInstance;
                localState.aiPricingComponent = aiPricingComponentInstance;
                // Mount the component to the current element
                (_a = localState.aiPricingComponent) === null || _a === void 0 ? void 0 : _a.mount(el);
            });
        };
        const mountAiPricingComponent = () => {
            mountAiPricingPage();
        };
        expose({
            mountAiPricingComponent,
            localState,
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1));
        };
    }
});
